/**
 * Fills a Google Form template URL with data.
 * @param {Object} data - The data object containing information to fill in the form.
 * @returns {string} - The filled Google Form URL.
 */
export function fillGoogleFormTemplate(data) {
  const placeholders = {
    region: 'Région',
    name: "Nom de l'organisme",
    phone: 'Téléphone',
    emails: 'Courriels carte',
    website: 'Site internet',
    facebook: 'Facebook',
    instagram: 'Instagram',
    address: 'Adresse',
    city: 'Ville',
    postcode: 'Code postal',
    territory: 'Territoire couvert'
  }

  const templateUrl =
    'https://docs.google.com/forms/d/e/1FAIpQLSf7_u31rlzDEEHyhhyzPyLimmv2-rr-7FU2QCPYpK-OAYVRWA/viewform?usp=pp_url&entry.1430557384=region&entry.1403894073=name&entry.1798809082=phone&entry.1171732799=emails&entry.731710104=website&entry.1622867443=facebook&entry.581129910=instagram&entry.1620757613=address&entry.1164772341=city&entry.1030677730=postcode&entry.2075776849=territory'

  return Object.entries(placeholders).reduce((filledUrl, [key, value]) => {
    const placeholder = new RegExp(key, 'g')
    return filledUrl.replace(placeholder, data[value] || '')
  }, templateUrl)
}

function getError(emailCandidate, item, index, emailRegex) {
  let error = null
  if (emailCandidate === '') {
    error = `${item["Nom de l'organisme"]} (ligne ${index + 2}): courriel vide`
  } else if (!emailRegex.test(emailCandidate)) {
    error = `${item["Nom de l'organisme"]} (ligne ${
      index + 2
    }): courriel invalide`
  }
  return error
}

function validateEmails(dataArray) {
  return dataArray.reduce((errors, item, index) => {
    const emailCandidate = item['Courriel admin'].trim()
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
    const error = getError(emailCandidate, item, index, emailRegex)
    return error ? [...errors, { index, message: error }] : errors
  }, [])
}

/**
 * Converts an array of data objects into an array of objects with email and filled Google Form URL.
 * @param {Object[]} dataArray - The array of data objects.
 * @returns {Object[]} - The array of objects with email and filled Google Form URL.
 */
export function getMailingData(dataArray) {
  const notEmptyData = dataArray.filter(item => item["Nom de l'organisme"])
  const errors = validateEmails(notEmptyData)
  const data = notEmptyData
    .filter((item, index) => !errors.find(error => error.index === index))
    .map(item => ({
      email: item['Courriel admin'],
      lien_formulaire: fillGoogleFormTemplate(item)
    }))
  return { data, errors }
}

/**
 * Converts an array of JSON data into a CSV string.
 * @param {Object[]} jsonData - The array of JSON data objects.
 * @returns {string} - The CSV content as a string.
 */
export function convertToCSV(jsonData) {
  const keys = Object.keys(jsonData[0])
  const headerRow = keys.map(key => `"${key}"`).join(',')
  const dataRows = jsonData.map(row => {
    return keys.map(key => `"${row[key]}"`).join(',')
  })
  const csvContent = `${headerRow}\n${dataRows.join('\n')}`
  return csvContent
}
